import { defineMessages } from "react-intl";

export const FORM_VALIDATION_MESSAGES = defineMessages({
    required: {
        id: "form.required",
        defaultMessage: "{label} is required!"
    }
});